import { Div } from "@tblabs/truffle";
import { Order } from "../../../../../../Models/Order";
import { AdminBasketTableItem, AdminBasketTableItemV2 } from "./BasketTableItem";


export class BasketList extends Div
{
    constructor(order: Order, showTotalPrice: boolean = true)
    {
        super();
        
        const items = order.BasketItems;
        const totalPrice = order.BasketValue + "zł";
        const totalDeposit = order.DesiredDeposit + "zł";

        this.Append(
            ...items.map(x => new AdminBasketTableItem(x)),
            showTotalPrice && new Div()
                .Text(totalPrice  + " + " + totalDeposit)
                .Style(`border-top: 1px dashed #ccc; color: #aaa; width: 82%; margin: 2px auto 0; text-align: center;  font-size: 12px`),
        );
    }
}

 
 
export class BasketListInBasketInfo extends Div
{
    constructor(order: Order, showTotalPrice: boolean = true)
    {
        super();

        const items = order.BasketItems;
        const totalPrice = order.BasketValue + "zł";
        const totalDeposit = order.DesiredDeposit + "zł";

        this.Append(
            new Div("tab-content__title").Text("Produkty w koszyku"),
            new Div("tab-content__list").Append(
                ...items.map(x => new AdminBasketTableItemV2(x)),
            ),
            showTotalPrice && new Div().Text(totalPrice  + " + " + totalDeposit)
                .Style(`border-top: 1px dashed #ccc; color: #aaa; width: 82%; margin: 2px auto 0; text-align: center;  font-size: 12px`),
        );
    }
}
